import React, { useRef } from 'react';

import './SignalTileChart.scss';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext';
import { scaleLinear } from 'd3-scale';
import { styleConstants as tileStyleConstants } from 'widgets/tiles/components/styles/variables.module.constants';
import { TileTimeSeriesChart } from 'widgets/tiles/components/tile/TileTimeSeriesChart';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { SignalTileDataState } from 'widgets/signalTiles/signalTile/state/stream/SignalTileStreamState';
import { buildSignalTileChartData } from './signalTileData';
import { AnySeries } from '@d3fc/d3fc-series';
import { useWidgetContext } from 'widgets/WidgetContext';
import { SignalTileChartValue } from './SignalTileChartValue';

interface SignalTileChartProps {
    config: SignalTileConfigState;
    streamData: SignalTileDataState;
    domain: [number, number];
    series: AnySeries;
    upperBoundary: number;
    lowerBoundary: number;
}

export function SignalTileChart(props: SignalTileChartProps) {
    const { config, domain, series, streamData, upperBoundary, lowerBoundary } =
        props;
    const chartData = buildSignalTileChartData(
        upperBoundary,
        lowerBoundary,
        config,
        streamData
    );
    const { widgetKey } = useWidgetContext();

    const height =
        tileStyleConstants.tileHeight -
        tileStyleConstants.tileWidgetToolbarHeight -
        tileStyleConstants.tileWidgetToolbarMarginTop;
    const yScaleRef = useRef(scaleLinear());
    yScaleRef.current.domain(domain);

    if (!chartData) {
        return <div className="SignalTileChart">No Data</div>;
    }
    const { startTime, endTime, timeSeries } = chartData;

    return (
        <div className="SignalTileChart">
            {startTime && endTime && (
                <XAxisContextProvider
                    timeSeriesChartWidth={tileStyleConstants.tileWidth}
                    startTime={startTime}
                    endTime={endTime}
                    breaks={[]}
                    rangeLabels={[]}
                    timeLineLabels={[]}
                >
                    <SignalTileChartValue chartData={chartData} />
                    <TileTimeSeriesChart
                        id={`SignalTileTimeSeriesChart-${widgetKey}`}
                        height={height}
                        data={timeSeries}
                        series={series}
                        displayXAxis={true}
                        yScale={yScaleRef.current}
                        yTicks={0}
                    />
                </XAxisContextProvider>
            )}
        </div>
    );
}
